import { churchesApi } from '../api/churchesApi'
import type { ChurchCreateInput } from '../types/church'

export const addChurch = async (church: ChurchCreateInput) => {
  try {
    const { data } = await churchesApi.createChurch(church)
    return data
  } catch (error) {
    console.error(`Error creating church: `, error)
    throw error
  }
}
